import {futureDateValidator} from '@/common/validator/futureDateValidator';
import {CommonModule} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {
    FormGroup,
    FormBuilder,
    Validators,
    ReactiveFormsModule
} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {LoaderService} from '@services/loader.service';
import {MedicationService} from '@services/medication.service';
import {FarmService} from '@services/farm.service';
import {ToastrService} from 'ngx-toastr';
import {Observable} from 'rxjs';
import {MedicationUnitOptions} from '@/common/Enum/MedicationType.Enum';

@Component({
    selector: 'app-edit-medication',
    standalone: true,
    imports: [ReactiveFormsModule, CommonModule],
    templateUrl: './edit-medication.component.html',
    styleUrl: './edit-medication.component.scss'
})
export class EditMedicationComponent implements OnInit {
    public medicationForm: FormGroup;
    public currentDate: string;
    public farms: any[] = [];
    public classifications: any[] = [];
    public suppliers: any[] = [];
    public applications: any[] = [];
    public chickTypes: any[] = [];
    public isAuthLoading = false;
    public isLoading$: Observable<boolean>;
    public UserDetail: any;
    public medicationId: number;
    public medicationUnitOptions = MedicationUnitOptions;

    constructor(
        private fb: FormBuilder,
        private toastr: ToastrService,
        private loaderService: LoaderService,
        private medicationService: MedicationService,
        private farmService: FarmService,
        private router: Router,
        private route: ActivatedRoute
    ) {}

    ngOnInit(): void {
        this.medicationId = this.route.snapshot.params['id'];
        this.UserDetail = JSON.parse(localStorage.getItem('UserDetail'));
        const today = new Date();
        this.currentDate = today.toISOString().split('T')[0]; // Format as YYYY-MM-DD
        this.medicationForm = this.fb.group({
            name: ['', Validators.required],
            arabicBrandName: ['', Validators.pattern(/^[\u0600-\u06FF0-9-\s]+$/)],
            supplierId: ['', Validators.required],
            farmId: ['', Validators.required],
            minimumStockAlert: ['', [Validators.required, Validators.min(0)]],
            medicationUnit: ['', Validators.required],
            expiryDate: ['', [Validators.required, futureDateValidator()]],
            chickTypeId: ['', Validators.required],
            description: [''],
            applicationId: ['', Validators.required],
            batchNumber: ['', Validators.required],
            qty: ['', [Validators.required, Validators.min(0)]],
            chickAgeFrom: ['', [Validators.required, Validators.min(0)]],
            chickAgeto: ['', [Validators.required, Validators.min(0)]],
            classificationId: ['', Validators.required],
            userId: this.UserDetail.id
        });
        this.getChicksTypeList();
        this.getApplicationTypeList();
        this.getClassificationTypeList();
        this.getSupplierTypeList();
        this.getFarmTypeList();

        if (this.medicationId) {
            this.GetMedicationDetailsById(this.medicationId);
        }
    }

    GetMedicationDetailsById(MedicationId: any) {
        this.medicationService
            .getMedicationById(MedicationId)
            .subscribe((response: any) => {
                if (response.expiryDate) {
                    const dateObj = new Date(response.expiryDate);
                    const formattedDate = dateObj.toISOString().split('T')[0];
                    response.expiryDate = formattedDate;
                }
                this.medicationForm.patchValue(response);
            });
    }

    // Direct focus to open the datepicker
    triggerDatePicker(event: any): void {
        const dateInput = event.target;
        dateInput.focus();
        dateInput.click();
    }
    getChicksTypeList() {
        this.medicationService.getChicksTypeList().subscribe((result) => {
            this.chickTypes = result;
        });
    }
    getApplicationTypeList() {
        this.medicationService.getApplicationTypeList().subscribe((result) => {
            this.applications = result;
        });
    }
    getClassificationTypeList() {
        this.medicationService.getClassificationList().subscribe((result) => {
            this.classifications = result;
        });
    }
    getSupplierTypeList() {
        this.medicationService.getSuppierList().subscribe((result) => {
            this.suppliers = result;
        });
    }

    getFarmTypeList() {
        this.farmService.getFarmList(this.UserDetail.id).subscribe((result) => {
            this.farms = result;
        });
    }

    onSubmit(): void {
        this.loaderService.showLoader();
        this.isAuthLoading = true;
        if (this.medicationForm.valid) {
            const medicationData = {
                ...this.medicationForm.value,
                id: this.medicationId
            };

            this.medicationService
                .updateMedicationDetail(medicationData)
                .subscribe({
                    next: (response) => {
                        setTimeout(() => {
                            this.isAuthLoading = false;
                            this.loaderService.hideLoader();
                            this.toastr.success(
                                'Medication detail Updated Successfully'
                            );
                        }, 2000);
                        this.router.navigate(['/medication-list']);
                    },
                    error: (error) => {
                        console.log(error);
                        setTimeout(() => {
                            this.isAuthLoading = false;
                            this.loaderService.hideLoader();
                            this.toastr.error(error.error);
                        }, 2000);
                    }
                });
        } else {
            this.loaderService.hideLoader();
            this.medicationForm.markAllAsTouched();
            this.isAuthLoading = false;
            this.toastr.error('Please fill the required fields');
        }
    }

    navigateBack(): void {
        this.router.navigate(['/medication-list']);
    }
}
